/**
 * Created by andrey on 16.07.2025
 */

const UnitLibraryIconPrize = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.UnitLibraryIconPrize;

        if (styles.background) {
            const background = this.background = new cleverapps.Spine(bundles.unitslibrarywindow.jsons.icon_prize_background_json);
            this.setContentSize(background.width, background.height);
            background.setAlignment({ align: "center" }, { align: "center" });
            background.setAnimation(0, "animation", true);
            this.addChild(background);
        }

        if (styles.coin) {
            const coin = this.coin = new cc.Sprite(bundles.reward_icons.frames.reward_coin_png);
            if (!this.background) {
                this.setContentSize(coin.getContentSize());
            }
            coin.setAlignment({ align: "center" }, { align: "center" });
            this.addChild(coin);
            cleverapps.UI.applyHover(coin);
        }

        if (styles.prize) {
            const prize = new cleverapps.Spine(bundles.merge.jsons.big_prize_json);
            prize.setAnimation(0, "idle", true);

            this.prize = prize;

            prize.setScale(styles.prize.scale || 1);
            prize.baseScale = prize.scale;
            if (!this.background) {
                this.setContentSize(prize.width * prize.scale, prize.height * prize.scale);
            }
            prize.setAlignment({ align: "center" }, { align: "center" });
            this.addChild(prize);
            cleverapps.UI.applyHover(prize);
        }
    },

    openAnimation: function () {
        if (this.prize) {
            this.prize.setAnimation(0, "open", false);
            this.prize.setCompleteListenerRemove();
        }

        this.coin && this.coin.removeFromParent();

        if (this.background) {
            this.background.setAnimation(0, "open", false);
            this.background.setCompleteListener(() => {
                this.removeFromParent();
            });
        }

        cleverapps.effects.fire("unitslibrary.window.prize.open");
    }
});

cleverapps.styles.UnitLibraryIconPrize = {
    prize: true
};